export function isAltTheme(theme) {
    if (theme === 'secondary-4' || theme === 'secondary-5' || theme === 'tertiary-4') {
        return true;
    }
    return false;
}
